export default {
  zh: {
    // 归一化
    RESTUDY_MODULE: "重学",
    SURFACE_RESTUDY_MODULE: "重学",
    STUDY_MODULE: "学习",
    TEST_MODULE: "测试",
    REVIEW_MODULE: "复习",
    TEST_CHECK_MODULE: "补漏测",
    SURFACE_TEST_MODULE: "补漏测",
    STUDY_CHECK_MODULE: "补漏学",
    SURFACE_STUDY_MODULE: "补漏学",
    REVIEW_TEST_MODULE: "遗忘测",
    REVIEW_STUDY_MODULE: "遗忘学",
    // 统一流程
    100001: "边学边练",
    100002: "识记测评",
    100003: "识记边学边练",
    100004: "运用先行测试",
    100005: "运用边学边练",
    100006: "拓展先行测试",
    100007: "拓展边学边练",
    100008: "定级测试",
    100009: "知识点练习",
    100010: "知识点练习阶段错题重做",
    100011: "综合语篇练习",
    100012: "综合练习阶段错题重做",
    100013: "综合语篇测试",
    100014: "顶级学习",
    100015: "顶级阶段错题重做",
    100016: "听音跟读",
    100017: "词汇阶段学前测评",
    100018: "边学边练听音跟读",
    100019: "边学边练练习",
    100020: "拓展练习",
    100021: "语音学习测试",
    100022: "综合测试",
    100023: "语法先行测试",
    100024: "绘本阅读先测",
    100025: "绘本阅读边学边练",
    100026: "学前测评定级",
    100027: "听力测试",
    100028: "阅读先行测试",
    100029: "阅读边学边练",
    100030: "基础词汇先测",
    100031: "基础词汇边学边练",
    100032: "基础词汇综合测试",
    100033: "基础词汇补充学练",
    100034: "拓展词汇先测",
    100035: "拓展词汇边学边练",
    100036: "全推测试",
    200001: "预先测",
    200002: "前序学习",
    200003: "高效学习",
    200004: "学习检测",
    200005: "L1基础测试学习-学习-巩固学习",
    200006: "L1基础测试学习-先行测试",
    200007: "L1基础测试学习-学习-基础学习",
    200008: "综合学习-整体提升",
    200009: "综合学习-查缺补漏",
    200010: "概念知识点测试",
    200011: "概念知识点学习",
    200012: "纳米知识点测试",
    200013: "纳米知识点学习",
    200014: "专题知识点测试",
    200015: "专题知识点学习",
    200016: "高中数学暑期预习",
    300001: "边学边练A",
    300002: "边学边练B",
    300003: "文海遨游",
    300004: "知识点学习",
    300005: "限时写作",
    300006: "美文赏析",
    300007: "音乐尾曲",
    300008: "学习指导",
    300009: "分级测试",
    300010: "学前测试",
    300011: "综合测试1",
    300012: "综合测试2",
    300013: "小试牛刀",
    400001: "课前复习",
    400002: "知识点学习（一）",
    400003: "知识点学习（二）",
    400004: "综合学习",
    400005: "巩固测试",
    400006: "竞赛拓展",
    400007: "趣味pk",
    500001: "课前复习",
    500002: "知识点学习（一）",
    500003: "知识点学习（二）",
    500004: "综合学习",
    500005: "巩固测试",
    500006: "竞赛拓展",
    500007: "趣味pk",
    990001: "先行测试",
    990002: "遗忘复习",
    990003: "综合测试",
    990004: "压轴题20年春季",
    990005: "同步学习",
    990006: "同步学习",
    990007: "同步学习",
  },
  en: {
    RESTUDY_MODULE: "Restudy",
    SURFACE_RESTUDY_MODULE: "Restudy",
    STUDY_MODULE: "Learning",
    TEST_MODULE: "Test",
    REVIEW_MODULE: "Review",
    TEST_CHECK_MODULE: "Knowledge gap assessment",
    SURFACE_TEST_MODULE: "Knowledge gap assessment",
    STUDY_CHECK_MODULE: "Knowledge gap learning",
    SURFACE_STUDY_MODULE: "Knowledge gap learning",
    // 统一流程
    100001: "Learn & Practice",
    100002: "Memory Assessment",
    100003: "Memory Learn & Practice",
    100004: "Application Pre-test",
    100005: "Application Learn & Practice",
    100006: "Extension Pre-test",
    100007: "Extension Learn & Practice",
    100008: "Level Test",
    100009: "Key Points Practice",
    100010: "Retake Key Points Mistakes",
    100011: "Comprehensive Passage Practice",
    100012: "Retake Comprehensive Mistakes",
    100013: "Comprehensive Passage Test",
    100014: "Top-Level Learning",
    100015: "Retake Top-Level Mistakes",
    100016: "Listen & Repeat",
    100017: "Vocabulary Pre-assessment",
    100018: "Learn & Practice Listen & Repeat",
    100019: "Learn & Practice Exercises",
    100020: "Extension Exercises",
    100021: "Pronunciation Test",
    100022: "Comprehensive Test",
    100023: "Grammar Pre-test",
    100024: "Illustrated Book Pre-test",
    100025: "Illustrated Book Learn & Practice",
    100026: "Pre-assessment Leveling",
    100027: "Listening Test",
    100028: "Reading Pre-test",
    100029: "Reading Learn & Practice",
    100030: "Basic Vocabulary Pre-test",
    100031: "Basic Vocabulary Learn & Practice",
    100032: "Basic Vocabulary Comprehensive Test",
    100033: "Basic Vocabulary Supplemental Practice",
    100034: "Extension Vocabulary Pre-test",
    100035: "Extension Vocabulary Learn & Practice",
    100036: "Full Test",
    200001: "Pre-assessment",
    200002: "Prerequisite Learning",
    200003: "Efficient Learning",
    200004: "Learning Check",
    200005: "L1 Foundation Test - Learn - Consolidate",
    200006: "L1 Foundation Test - Pre-test",
    200007: "L1 Foundation Test - Learn - Basic",
    200008: "Comprehensive Learning - Overall Improvement",
    200009: "Comprehensive Learning - Fill Gaps",
    200010: "Concept Key Points Test",
    200011: "Concept Key Points Learning",
    200012: "Nano Key Points Test",
    200013: "Nano Key Points Learning",
    200014: "Special Topic Key Points Test",
    200015: "Special Topic Key Points Learning",
    200016: "High School Math Summer Preview",
    300001: "Learn & Practice A",
    300002: "Learn & Practice B",
    300003: "Ocean of Texts",
    300004: "Key Points Learning",
    300005: "Timed Writing",
    300006: "Appreciation of Fine Writings",
    300007: "Music Finale",
    300008: "Learning Guidance",
    300009: "Grading Test",
    300010: "Pre-assessment Test",
    300011: "Comprehensive Test 1",
    300012: "Comprehensive Test 2",
    300013: "Trial Run",
    400001: "Pre-class Review",
    400002: "Key Points Learning (Part 1)",
    400003: "Key Points Learning (Part 2)",
    400004: "Comprehensive Learning",
    400005: "Consolidation Test",
    400006: "Competition Extension",
    400007: "Fun PK",
    500001: "Pre-class Review",
    500002: "Key Points Learning (Part 1)",
    500003: "Key Points Learning (Part 2)",
    500004: "Comprehensive Learning",
    500005: "Consolidation Test",
    500006: "Competition Extension",
    500007: "Fun PK",
    990001: "Pre-test",
    990002: "Forgotten Review",
    990003: "Comprehensive Test",
    990004: "Final Spring Challenge",
    990005: "Synchronized Learning",
    990006: "Synchronized Learning",
    990007: "Synchronized Learning",
  },
};



// WEBPACK FOOTER //
// ./src/utils/lang-map.js